import type { HttpService } from '@empathyco/playboard-core-domain'
import type { PivotableToolConfig } from '../models'
import type { ContextProvider } from '../providers'
import type { SearchToolingService } from './interfaces'
import { interpolate } from '@empathyco/x-adapter'
import { inject, injectable } from 'inversify'
import { TYPES } from '../config/inversify.types'

@injectable()
export class PlatformSearchToolingService implements SearchToolingService {
  public constructor(
    @inject(TYPES.HttpService) protected httpService: HttpService,
    @inject(TYPES.SearchUrl) protected url: string,
    @inject(TYPES.ContextProvider) protected contextProvider: ContextProvider,
    protected endpoints = {
      instanceConfig: '/configurations/clients/{instance}',
    },
  ) {}

  async getInstanceConfig(): Promise<PivotableToolConfig> {
    try {
      const response = await this.httpService.get<PivotableToolConfig>(
        this.buildRequestUrl(this.endpoints.instanceConfig),
        {
          addAccessToken: true,
        },
      )
      return Object.assign({ pivots: [] }, response.data)
    } catch (error) {
      throw error
    }
  }

  private buildRequestUrl(endpoint: string, parameters: Record<string, any> = {}): string {
    const url = `${this.url}${endpoint}`
    const { instanceId: instance } = this.contextProvider()
    if (!instance) {
      throw new Error('instance is not defined')
    }
    return interpolate(url, { instance, ...parameters })
  }
}
